module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Aktivitäten","action-reload":"Neu laden","msg-no-data":"Es gibt keine History-Aktivitäten"},"fr":{"action-reload":"Recharger","msg-no-data":"Il n’y a pas d’activité d’historique","title":"Activités"},"it":{"action-reload":"Caricare nuovamente","msg-no-data":"Non ci sono voci nella cronologia","title":"Attività"}}')
  delete Component.options._Ctor
}
